<template>
  <div
    class="mui-alertbox"
    :class="[
      `mui-alertbox--${type}`,
      {'mui-alertbox--non-closable' : !closeButton}
    ]"
		v-show="isActive"
  >
    <ion-icon v-if="type === 'error'" name="close-circle"></ion-icon>
    <ion-icon v-else-if="type === 'info'" name="information-circle"></ion-icon>
    <ion-icon v-else name="alert-circle"></ion-icon>

    <div class="mui-alertbox__content">
      <p class="mui-alertbox__title">{{ title }}</p>
      <slot>
        <div class="mui-alertbox__description" v-html="description"></div>
      </slot>
    </div>

    <button
      v-if="closeButton"
      type="button"
      class="button-no-style mui-alertbox__close-button"
      aria-label="Fechar"
      @click="close"
    >
      <ion-icon name="close-outline"></ion-icon>
    </button>
  </div>
</template>

<script>
export default {
  props: {

		/**
		 * The alertbox title.
		 */
		title: {
			type: String,
			required: true
		},

		/**
		 * The alertbox description.
		 */
		description: {
			type: String,
			default: ''
		},

		/**
		 * The alertbox type.
		 * @values: 'alert', 'error', 'info'
		 */
		type: {
			type: String,
			default: 'alert',
			validator: function (value) {
				return ['alert', 'error', 'info'].includes(value);
			}
		},

		/**
		 * Defines whether to show the close button
		 * @values: 'true', 'false'
		 */
		closeButton: {
			type: Boolean,
			default: true
		}
	},

	data() {
		return {

			/**
			 * Whether the alertbox is open or not.
			 */
			isActive: true
		};
	},

	methods: {

		/**
		 * Close the alertbox.
		 * @returns {void}
		 */
		close() {
			this.isActive = false;
		}
	}
}
</script>

<style lang="stylus" scoped>
.mui-alertbox
  background-color white
  padding 16px
  box-shadow 0 5px 8px rgba(38, 48, 60, 0.15)
  border-left 4px solid #556976
  border-radius 0 4px 4px 0
  text-align left
  font-family Lato
  display flex
  justify-content space-between
  align-items flex-start
  gap 16px

  &--non-closable
    justify-content flex-start

  &--alert
    border-color #FE9037
    ion-icon
      color #FE9037

  &--error
    border-color #E7505A
    ion-icon
      color #E7505A

  &--info
    border-color #3598DC
    ion-icon
      color #3598DC

  &__content
    flex-grow 1

  &__title
    color #3B3F51
    font-size 14px
    font-weight bold
    margin-bottom 4px

  &__description
    font-size 12px
    color #697882
    overflow-wrap break-word
    line-height 1.25

    a
      color #00519D
      text-decoration underline
      margin 0 !important

    strong
      font-weight bold

  ion-icon
    min-width 24px
    font-size 24px
    pointer-events none

  &__close-button
    width 26px
    height 26px
    cursor pointer

    ion-icon
      color #697882
      font-size 14px

</style>
